module.exports = __webpack_public_path__ + "img/csjx.7f96e223.png";